// @ts-check

import { nextTick } from 'vue'

/**
 * Scrolls into first element that has a failed validation in the given component.
 * Works with BaseErrors.vue
 * @param {any} component
 */
export const scrollIntoError = (component) => {
  nextTick(() => {
    const legacyError = (component.$el ?? component)?.querySelector?.(
      '.error-container > [role="alert"]'
    )

    const vuetifyError = (component.$el ?? component)?.querySelector?.(
      '.v-input--error'
    )

    const error = legacyError ?? vuetifyError

    error?.scrollIntoView?.({
      block: 'center',
      behavior: 'smooth'
    })
  })
}

export default {
  scrollIntoError
}
